module.exports = __webpack_public_path__ + "img/Bear22.2118e5c7.jpg";